import { render, staticRenderFns } from "./FriendUserItem.vue?vue&type=template&id=273deb36"
import script from "./FriendUserItem.vue?vue&type=script&lang=js"
export * from "./FriendUserItem.vue?vue&type=script&lang=js"
import style0 from "./FriendUserItem.vue?vue&type=style&index=0&id=273deb36&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports